import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ViewProfile } from '@/features/cleaner/view-profile';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/view-profile'
)({
  component: ViewProfilePage,
});

function ViewProfilePage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>View profile</HeaderDashboard.Title>
        <HeaderDashboard.Action>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => navigate({ to: '/cleaner/edit-profile' })}
          >
            Edit profile
          </Button>
        </HeaderDashboard.Action>
      </HeaderDashboard>
      <div className="flex flex-col gap-6">
        <ViewProfile />
      </div>
    </div>
  );
}
